import React, { useContext, useState } from "react";
// import { FaRegMoon } from "react-icons/fa";
// import { FiSun } from "react-icons/fi";
// import { AppContextProvider } from "../../App";

const MobileMenu = ({author}) => {
  // const { toggleTheme } = useContext(AppContextProvider);
  // const [darkLight, setDarkLight] = useState(
  //   () => localStorage.getItem("dark") === "true"
  // );
  // const handleThemeToggle = (theme) => {
  //   localStorage.setItem("dark", theme === "dark");
  //   setDarkLight(theme === "dark");
  //   toggleTheme(theme);
  //   };
  const [id, setId] = useState(1);
  return (
    <div className="bg-white dark:bg-[#1C1C1C] dark:text-white drop-shadow-md lg:hidden  p-4 w-full h-auto">
      <ul className="text-center text-xl">
        <li className="border-b dark:border-gray-600 pb-2">
          <a href="/">All Products</a>
        </li>
        <li className="my-4 border-b dark:border-gray-600 pb-2">
          <a href="/Pages/plans">Pricing</a>
        </li>
        {!author &&
        <li className="border-b pb-2 dark:border-gray-600">
          <a href="/Pages/faq">Become an Author </a>
        </li>
        }
        {author &&
        <li className="border-b bg-white text-black px-4 py-2 rounded-lg w-full mx-auto my-4 pb-2 dark:border-gray-600">
          <a href="/Pages/authorDashboard">Author Dashboard </a>
        </li>
        }
      </ul>
      {/* <ul className="text-center text-xl">
        <li className="border-b dark:border-gray-600 pb-2">
          <a href="/">UX Flows</a>
        </li>
        <li className="my-4 border-b dark:border-gray-600 pb-2">
          <a href="/Pages/plans">Pricing</a>
        </li>
        <li className="border-b pb-2 dark:border-gray-600">
          <a href="/Pages/faq">FAQ</a>
        </li>
      </ul> */}

      {/* <----------------------- toggle light and dark mode -----------------------> */}
      {/* <div
        id="darklight"
        className="flex h-8 border dark:border-gray-500 rounded-lg "
      >
        <FiSun
          onClick={() => handleThemeToggle("light")}
          className={`cursor-pointer w-1/2 h-full text-3xl px-3 py-1 ${
            !darkLight ? "border border-black dark:border-white rounded-lg" : ""
          }`}
        />
        <FaRegMoon
          onClick={() => handleThemeToggle("dark")}
          className={`cursor-pointer w-1/2 h-full text-3xl px-3 py-1 ${
            darkLight ? "border border-black dark:border-white rounded-lg" : ""
          }`}
        />
      </div> */}
    </div>
  );
};

export default MobileMenu;
